import { Parser } from '@json2csv/plainjs';

interface UseCSVDownloadResult {
  downloadCSV: (filename: string, headers: string[], jsonData: unknown[]) => void;
}

const useCSVDownload = (): UseCSVDownloadResult => {
  const downloadCSV = (filename: string, headers: string[], jsonData: unknown[]) => {
    try {
      const opts = { fields: headers };
      const parser = new Parser(opts);
      const csv = parser.parse(jsonData);
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const timestamp = new Date().toISOString().replace(/[:.]/g, ''); // Replace colons and dots in ISO string
      link.download = `${filename}_${timestamp}.csv`;
      link.click();
    } catch (error) {
      console.error('Error converting JSON to CSV:', error);
    }
  };

  return {
    downloadCSV
  };
};

export default useCSVDownload;
